import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { StyleSheet, Linking } from "react-native";
import { CheckCircle } from "~/assets/static-icons/CheckCircle";
import { Screen } from "~/components/Screen";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { environment } from "~/environment";
import { logEvent } from "~/features/analytics/firebaseAnalytics";
import { styleConstants } from "~/style/styleConstants";
import { useErrorAlert } from "../../components/error-alert";

const styles = StyleSheet.create({
  screen: {
    paddingTop: 87,
    paddingHorizontal: styleConstants.spacingExtraLarge,
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: styleConstants.colorBackgroundWhite,
  },
});

export const SmsTosConsentSuccessScreen = observer(
  function SmsTosConsentSuccessScreen() {
    const errorAlert = useErrorAlert();

    useEffect(() => {
      logEvent("terms_approved");
    }, []);

    return (
      <Screen
        withBottomInset
        withTopInset={false}
        preventScroll
        style={styles.screen}
      >
        <Spacer extraExtraLarge />
        <CheckCircle color={styleConstants.colorBackgroundSuccess} />
        <Spacer extraLarge />
        <Text alignCenter weightBold sizeExtraExtraLarge>
          <FormattedMessage
            id="CyniKP"
            defaultMessage="Terms accepted"
            description="Text on the already accepted tos screen saying that the terms and conditions have been accepted."
          />
        </Text>
        <Spacer extraLarge />
        <Text alignCenter weightLight>
          <FormattedMessage
            id="oKvvWS"
            defaultMessage="Thank you for your acceptance! You can always access our <tosLink>terms and conditions</tosLink> on our website."
            description="Text on already accepted tos screen saying that the user has accepted the general terms and conditions."
            values={{
              tosLink: (chunks: React.ReactNode) => (
                <Text
                  weightBold
                  onPress={async () => {
                    try {
                      await Linking.openURL(environment.TOS_URL);
                    } catch (error) {
                      console.log("Error opening TOS link", error);
                      errorAlert(error);
                    }
                  }}
                  style={{
                    color: styleConstants.colorTextTheme,
                    textDecorationLine: "underline",
                  }}
                >
                  {chunks}
                </Text>
              ),
            }}
          />
        </Text>
      </Screen>
    );
  },
);
